import {
  AllTickets,
  NewTickets,
  OnGoingTickets,
  ResolvedTickets,
} from "../../icons";

export const supportTicketsTabsArray = [
  { icon: AllTickets, label: "All Tickets", key: "all-tickets" },
  { icon: NewTickets, label: "New", key: "new-tickets" },
  { icon: OnGoingTickets, label: "On-Going", key: "on-going-tickets" },
  { icon: ResolvedTickets, label: "Resolved", key: "resolved" },
];
